export default {
  config: {
    site: {
      name: '站点名称',
      domainName: '域名',
      siteID: '站点ID',
      siteCatalogs: '站点目录',
      status: '状态',
      recycle: '站点回收站'
    }
  }
}
